import { MailDataI } from "../models/models";

const getMailsRemovingStatus = (
  mailsData: { [key: string]: MailDataI },
  mailIdsForRemoving: string[]
) => {
  const result: { [key: string]: string } = {};

  for (const mailId of mailIdsForRemoving) {
    const isSavedByOtherUser = mailsData[mailId]?.isSavedByOtherUser;
    const isSavedByUser = mailsData[mailId]?.isSavedByUser;

    if (isSavedByOtherUser && !isSavedByUser) {
      // if saved by another user(s), not allow to remove the mail
      result[mailId] = "not allowed";
    } else if (isSavedByOtherUser && isSavedByUser) {
      // if saved by owner and by another user(s),
      // change status only from saved to active
      result[mailId] = "status change";
    } else {
      result[mailId] = "remove";
    }
  }

  return result;
};

export default getMailsRemovingStatus;
